import React, { useState } from "react";
import WOC_Winners from "../components/WoC/Winners";

// Matrial UI Compenets
import {
  Box,
  Zoom,
  Select,
  Tooltip,
  MenuItem,
  TextField,
  InputLabel,
  Typography,
  FormControl,
  InputAdornment,
  CircularProgress,
} from "@mui/material";

function WinnersPage() {
  const [event, setEvent] = useState("winter-of-code");
  return (
    <>
      {/* <Box
        sx={{ position: "fixed", top: 0, right: 0, width: 300, mx: 4, my: 8 }}
      >
        <FormControl size="small" fullWidth>
          <InputLabel
            id="preference1-label"
            sx={{
              color: "white",
              "&.Mui-focused": {
                color: "white", // Set label color to white when focused
              },
            }}
          >
            Event
          </InputLabel>
          <Select
            labelId="event-label"
            name="event"
            id="event"
            label="Event"
            value={event}
            onChange={(e) => setEvent(e.target.value)}
            sx={{
              borderRadius: 3,
              color: "white", // Set text color to white
              ".MuiSelect-icon": {
                color: "white", // Icon color
              },
              ".MuiOutlinedInput-notchedOutline": {
                borderColor: "white", // Border color when not focused
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "white", // Hover border color to white
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "white", // Focused border color to white
              },
              "&.Mui-focused .MuiInputLabel-root": {
                color: "white", // Focused label color to white
              },
            }}
          >
            <MenuItem value={"winter-of-code"}>
              <Typography fontWeight="bold">Winter of Code</Typography>
            </MenuItem>
            <MenuItem value={"face-off"}>
              <Typography fontWeight="bold">Face Off</Typography>
            </MenuItem>
            <MenuItem value={"Hacktoberfest"}>
              <Typography fontWeight="bold">Hacktoberfest</Typography>
            </MenuItem>
          </Select>
        </FormControl>
      </Box> */}
      <WOC_Winners />
    </>
  );
}

export default WinnersPage;
